import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import { useMutation } from "@apollo/client";
import { Card, IconButton } from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import { useFormik } from "formik";

import { SectionLoader } from "../../Components/SectionLoader";
import { DASHBOARD_PAGE } from "../../Utils/routePaths";

import { FORCE_RESET_RESEND_PWD } from "./graphQl/mutation";
import { useForceResetPasswordValidationSchema } from "./useForceResetPasswordValidationSchema";

export const ForceResetPassword = () => {
  const {
    initialValues,
    forceResetPasswordValidationSchema,
  } = useForceResetPasswordValidationSchema();

  // Fields
  const [loading, setloading] = useState(false);

  const [passwordVisible, setPasswordVisible] = useState(false);

  const history = useHistory();

  const [
    forceResetPwdAction,
    {
      loading: forceResetPwdActionLoading,
      error: forceResetPwdActionError,
      data: forceResetPwdActionData,
    },
  ] = useMutation(FORCE_RESET_RESEND_PWD, {
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (forceResetPwdActionLoading) setloading(true);
    if (forceResetPwdActionError) {
      toast.error(
        forceResetPwdActionError.toString().replace("Error: Error:", ""),
        {
          position: toast.POSITION.TOP_RIGHT,
        },
      );
      setloading(false);
    }

    if (forceResetPwdActionData) {
      setloading(false);
      toast.success("Password reset successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
      history.push(DASHBOARD_PAGE);
    }
  }, [
    forceResetPwdActionData,
    forceResetPwdActionError,
    forceResetPwdActionLoading,
    history,
  ]);

  // Methods
  const saveUser = (values, setStatus, setSubmitting) => {
    setloading(true);
    setSubmitting(false);
    forceResetPwdAction({
      variables: {
        password: values.password,
        oldPass: values.currentPassword,
      },
    });
  }; // UI Helpers

  const getInputClasses = fieldname => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: forceResetPasswordValidationSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      saveUser(values, setStatus, setSubmitting);
    },
    onReset: (values, { resetForm }) => {
      resetForm();
    },
  });

  function handlePasswordClick() {
    setPasswordVisible(!passwordVisible);
  }

  return (
    <div className="login-form login-forgot" style={{ display: "block" }}>
      <div className="logo-text">equipbid</div>

      <h3 className="page-heading">Reset Password </h3>

      <form onSubmit={formik.handleSubmit}>
        <SectionLoader loader={loading} />
        <Card>
          {/* begin::Form */}
          <div className="form">
            <div className="card-body">
              <div className="form-group row position-relative">
                <label className="col-xl-3 col-lg-3 col-form-label text-alert">
                  New Password
                </label>
                <div className="col-lg-9 col-xl-6">
                  <input
                    type={passwordVisible ? "text" : "password"}
                    placeholder="New Password"
                    className={`form-control form-control-lg form-control-solid ${getInputClasses(
                      "password",
                    )}`}
                    name="password"
                    {...formik.getFieldProps("password")}
                  />
                  <p
                    className="hide-password-set"
                    style={{
                      top: "5px",
                      right: "13px",
                      position: "absolute",
                    }}
                  >
                    <IconButton
                      aria-label="visiblity"
                      onClick={handlePasswordClick}
                    >
                      {passwordVisible ? (
                        <VisibilityOffIcon />
                      ) : (
                        <VisibilityIcon />
                      )}
                    </IconButton>
                  </p>
                  {(formik.touched.password && formik.errors.password) && (
                    <div className="invalid-feedback">
                      {formik.errors.password}
                    </div>
                  )}
                </div>
              </div>
              <div className="form-group row">
                <label className="col-xl-3 col-lg-3 col-form-label text-alert">
                  Verify Password
                </label>
                <div className="col-lg-9 col-xl-6">
                  <input
                    type="password"
                    placeholder="Verify Password"
                    className={`form-control form-control-lg form-control-solid ${getInputClasses(
                      "cPassword",
                    )}`}
                    name="cPassword"
                    {...formik.getFieldProps("cPassword")}
                  />
                  {(formik.touched.cPassword && formik.errors.cPassword) && (
                    <div className="invalid-feedback">
                      {formik.errors.cPassword}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* end::Form */}
          <div className="form-group">
            <div className="d-flex jusify-content-center flex-column">
              <button
                id="kt_login_signin_submit"
                type="submit"
                disabled={formik.isSubmitting}
                className={"btn btn-outline-secondary bg-white mui_btn"}
              >
                <span>Submit</span>
              </button>
            </div>
          </div>
        </Card>
      </form>
    </div>
  );
};
